module.exports = __webpack_public_path__ + "src/assets/games/15/110.jpg";